export default __webpack_public_path__ + "static/Tech-Leaders-banner-8fade4c280ced90a2453bb12c455c166.webp";